import PropTypes from "prop-types";
import {Dropdown} from "primereact/dropdown";



export function DepartmentReselect(props) {

    const handleChange = (event) => {
        const myValue =props.departmentList.find(x=>x.id===event.target.value)
        props.setDepartment(myValue);

    };

    return (

            <Dropdown value={props.department.id} onChange={handleChange} options={props.departmentList}
                      optionLabel="name" optionValue="id" disabled={props.disabled}
                     variant="filled" className="w-full mt-2 md:w-4 h-2rem align-items-center"  />

    )

}
DepartmentReselect.propTypes = {
    departmentList: PropTypes.array.isRequired,
    department: PropTypes.object.isRequired,
    setDepartment: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,


}
